export default "__VITE_ASSET__Co9OPQfn__"